import Show from '../../Show/Show';
import ToggleFeatherIcon from './ToggleFeatherIcon';
import ToggleMaterialIcon from './ToggleMaterialIcon';
import styled from 'styled-components/native';
import { COLORS } from '../../../config/designSystem/Colors';
import { Feather } from '@expo/vector-icons';
import { PropsWithChildren } from 'react';
import { TouchableOpacity, View } from 'react-native';


interface ButtonProps extends PropsWithChildren {
  onPress: () => void;
  variant?: 'on' | 'off';
}
const buttonColors = {
  off: COLORS.surface['inverse-primary'],
  on: COLORS.surface.contrast,
};
const Button = styled(TouchableOpacity)<ButtonProps>`
  background-color: ${({variant = 'on'}) => buttonColors[variant]};
  shadow-color: ${COLORS.brand[10]};
  shadow-offset: 2px 2px;
  shadow-opacity: 0.5;
  shadow-radius: 4px;
  border-radius: 80px;
`;
interface ToggleProps extends Omit<ButtonProps, 'variant'> {
  pressed: boolean;
}
const Toggle = ({pressed, ...props}: ToggleProps) => {
  return (
    <Button
      {...props}
      variant={pressed ? 'on' : 'off'}
    >
      {props.children}
    </Button>
  );
};

const VideoCallButtons = ({
  toggleAudio = () => {return;},
  toggleVideo = () => {return;},
  reverseCamera = undefined as (() => void) | undefined,
  videoOn = undefined as boolean | undefined,
  audioOn = undefined as boolean | undefined,
  useFrontCamera = undefined as boolean | undefined,
  endCall = () => {return;},
  size = 24,
}) => {
  return (
    <View
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: size,
        zIndex: 100,
      }}
    >
      <Toggle
        onPress={toggleAudio}
        pressed={!!audioOn}
      >
        <ToggleFeatherIcon
          on="mic"
          off="mic-off"
          size={size}
          style={{padding: size * 0.5}}
          pressed={!!audioOn}
        />
      </Toggle>
      <Toggle
        onPress={toggleVideo}
        pressed={!!videoOn}
      >
        <ToggleFeatherIcon
          on="video"
          off="video-off"
          size={size}
          style={{padding: size * 0.5}}
          pressed={!!videoOn}
        />
      </Toggle>
      <Show when={reverseCamera} keyed>
        {onPress => (
          <Toggle
            onPress={onPress}
            pressed={!!useFrontCamera}
          >
            <ToggleMaterialIcon
              on="camera-front"
              off="camera-rear"
              size={size}
              style={{padding: size * 0.5}}
              pressed={!!useFrontCamera}
            />
          </Toggle>
        )}
      </Show>
      <Button
        variant='on'
        onPress={endCall}
      >
        <Feather
          name="phone"
          size={size}
          padding={size * 0.5}
          style={{padding: size * 0.5}}
          color={COLORS.state.danger.primary}
        />
      </Button>
    </View>
  );
};

export default VideoCallButtons;
